/* ZilZal - game picker sheet behaviour.

   1. On phones the panel is moved to <body>, because position:fixed resolves
      against the nearest ancestor with transform/filter/backdrop-filter/
      contain, and the header chain has several.
   2. Injects the title row and close button.

   SEARCH FIELD REMOVED FOR NOW.
   Cause of the bug it had: zz-menu.liquid closes the picker on any document
   click outside #zzgamepick. Once the panel is reparented to <body> it is no
   longer inside #zzgamepick, so tapping the input counted as an outside click
   and shut the sheet. Fixing it means widening that check to also ignore
   clicks inside .zzgp__panel, which lives in zz-menu.liquid. */
(function () {
  'use strict';

  var MOBILE = 749;
  var picker = null;
  var panel = null;
  var backdrop = null;
  var placeholder = null;

  function isPhone() { return window.innerWidth <= MOBILE; }
  function close() { if (picker) picker.classList.remove('is-open'); }

  function ensureBackdrop() {
    if (backdrop) return;
    backdrop = document.createElement('div');
    backdrop.className = 'zzgp-sheet-backdrop';
    backdrop.addEventListener('click', close);
    document.body.appendChild(backdrop);
  }

  function ensureHead() {
    if (!panel || panel.querySelector('.zzgp__sheethead')) return;
    var head = document.createElement('div');
    head.className = 'zzgp__sheethead';

    var title = document.createElement('span');
    title.className = 'zzgp__sheettitle';
    title.textContent = '\u0627\u062e\u062a\u0631 \u0644\u0639\u0628\u0629';

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'zzgp__sheetclose';
    btn.setAttribute('aria-label', '\u0625\u063a\u0644\u0627\u0642');
    btn.textContent = '\u00d7';
    btn.addEventListener('click', close);

    head.appendChild(title);
    head.appendChild(btn);
    panel.insertBefore(head, panel.firstChild);
  }

  /* Strip any search field left over from an earlier cached build. */
  function removeSearch() {
    if (!panel) return;
    var s = panel.querySelector('.zzgp__search');
    if (s) s.remove();
    var note = panel.querySelector('.zzgp__fbnote');
    if (note) note.remove();
    var none = panel.querySelector('[data-zzgp-none]');
    if (none) none.style.display = 'none';
  }

  function toSheet() {
    if (!panel || panel.classList.contains('zzgp-sheet')) return;
    placeholder = document.createComment('zzgp-panel');
    panel.parentNode.insertBefore(placeholder, panel);
    document.body.appendChild(panel);
    panel.classList.add('zzgp-sheet');
    ensureBackdrop();
    ensureHead();
  }

  function toDropdown() {
    if (!panel || !panel.classList.contains('zzgp-sheet')) return;
    panel.classList.remove('zzgp-sheet', 'is-open');
    if (placeholder && placeholder.parentNode) {
      placeholder.parentNode.insertBefore(panel, placeholder);
      placeholder.remove();
      placeholder = null;
    } else if (picker) {
      picker.appendChild(panel);
    }
    if (backdrop) backdrop.classList.remove('is-open');
    document.body.classList.remove('zzgp-open');
  }

  function sync() {
    if (!picker || !panel) return;
    var open = picker.classList.contains('is-open');
    if (panel.classList.contains('zzgp-sheet')) {
      panel.classList.toggle('is-open', open);
      if (backdrop) backdrop.classList.toggle('is-open', open);
      document.body.classList.toggle('zzgp-open', open);
    }
  }

  function init() {
    picker = document.getElementById('zzgamepick');
    if (!picker) return;
    panel = picker.querySelector('.zzgp__panel') || document.querySelector('.zzgp__panel.zzgp-sheet');
    if (!panel) return;

    if (isPhone()) toSheet();
    else toDropdown();

    removeSearch();

    if (!picker.hasAttribute('data-zzgp-sheetwired')) {
      picker.setAttribute('data-zzgp-sheetwired', '1');
      new MutationObserver(sync).observe(picker, { attributes: true, attributeFilter: ['class'] });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
      panel.addEventListener('click', function (e) { if (e.target.closest('a')) close(); });
    }
    sync();
  }

  function onResize() {
    if (!panel) return;
    if (isPhone()) toSheet();
    else toDropdown();
    sync();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  window.addEventListener('load', init);
  setTimeout(init, 700);
  setTimeout(init, 1700);

  var rt;
  window.addEventListener('resize', function () {
    clearTimeout(rt);
    rt = setTimeout(onResize, 150);
  });
})();
